const products = [
  {
    id: "vpn",
    name: "VPN",
    tagline: "Private & Secure Browsing",
    description:
      "A high-performance VPN application for iOS that encrypts your internet connection, masks your IP address, and protects your data on any network — public or private.",
    features: ["256-bit AES Encryption", "Zero-log Policy", "Global Server Network", "Kill Switch Protection"],
    badge: "Security",
    image:
      "https://public.readdy.ai/ai/img_res/aca72e17d39c79532cf1b7e9e621d3dc.jpg",
    accent: "bg-stone-900",
    accentText: "text-white",
  },
  {
    id: "cleaner",
    name: "Cleaner",
    tagline: "Optimize Your iPhone",
    description:
      "An intelligent iPhone cleaner that identifies and removes junk files, duplicate photos, and unused data to free up storage and keep your device running at peak performance.",
    features: ["Smart Junk Detection", "Duplicate Photo Finder", "Memory Booster", "Safe & Fast Cleanup"],
    badge: "Performance",
    image:
      "https://readdy.ai/api/search-image?query=iPhone%20cleaner%20app%20UI%20mockup%20with%20clean%20interface%2C%20broom%20or%20sparkle%20icon%2C%20light%20cream%20background%2C%20minimalist%20iOS%20design%2C%20professional%20product%20photograph%2C%20warm%20neutral%20tones%2C%20smooth%20gradients&width=480&height=560&seq=cleaner001&orientation=portrait",
    accent: "bg-[#f7f4ef]",
    accentText: "text-stone-700",
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="w-full bg-white py-24 md:py-36 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-20">
          <p className="text-stone-400 text-xs tracking-[0.25em] uppercase font-light mb-4">
            / Our Products
          </p>
          <h2
            className="font-light text-stone-900 leading-tight"
            style={{ fontSize: "clamp(2rem, 4vw, 3.2rem)" }}
          >
            Built for the iOS Platform
          </h2>
        </div>

        {/* Product Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {products.map((product) => (
            <article
              key={product.id}
              className="rounded-2xl overflow-hidden border border-stone-100 bg-[#f9f8f6] flex flex-col"
            >
              {/* Image area */}
              <div className="relative w-full overflow-hidden" style={{ height: "320px" }}>
                <img
                  src={product.image}
                  alt={`${product.name} iOS app`}
                  className="w-full h-full object-cover object-top"
                />
                {/* Badge */}
                <div className="absolute top-4 left-4">
                  <span className={`${product.accent} ${product.accentText} text-xs font-medium tracking-widest uppercase px-3 py-1.5 rounded-full`}>
                    {product.badge}
                  </span>
                </div>
              </div>

              {/* Info area */}
              <div className="p-8 flex flex-col gap-4 flex-1">
                <div>
                  <h3 className="text-stone-900 font-semibold text-2xl mb-1">{product.name}</h3>
                  <p className="text-stone-400 text-sm tracking-wide">{product.tagline}</p>
                </div>

                <p className="text-stone-500 font-light text-sm leading-relaxed">
                  {product.description}
                </p>

                {/* Feature list */}
                <ul className="mt-2 grid grid-cols-2 gap-x-4 gap-y-2">
                  {product.features.map((feat) => (
                    <li key={feat} className="flex items-center gap-2 text-stone-600 text-xs">
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-check-line text-stone-900 text-sm" />
                      </div>
                      <span>{feat}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>

        {/* Bottom note */}
        <p className="text-center text-stone-300 text-xs tracking-widest uppercase mt-16 font-light">
          Exclusively crafted for iOS &mdash; iPhone &amp; iPad
        </p>
      </div>
    </section>
  );
}
